// utils/parseMessage.js
export function parseMessage(message) {
  // Regex to match URLs starting with http:// or https://
  const urlRegex = /(https?:\/\/[^\s]+)/g;

  // Split message by URLs, keep URLs in the array
  const parts = message.split(urlRegex);

  return parts.map((part, index) => {
    // If part matches URL, return as object type 'link'
    if (urlRegex.test(part)) {
      return { type: "link", content: part, key: index };
    }
    // Else plain text
    return { type: "text", content: part, key: index };
  });
}
